import { useEffect, useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { getLocale } from "react-i18nify";

import { Stack } from "@mui/material";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import CloseIcon from "@mui/icons-material/Close";

import font from "src/styles/font";
import { Primary } from "src/styles/color";

import Button from "src/components/core/Button";
import ProductCardElement from "src/components/product/ProductCard";
import ProductDetail from "src/components/product/ProductDetail";

import { UseUpload } from "src/context/UploadProductContext";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 32,
  },
  "& .MuiDialogContent-root": {
    // maxHeight: "500px",
    border: 0,
    // paddingBottom: 0,
    paddingTop: 5,
  },
  // "& .MuiDialogActions-root": {
  //   justifyContent: "center",
  // },
}));

const DialogActions = muiStyled(MuiDialogActions)(({ theme }) => ({
  "&.MuiDialogActions-root": {
    borderRadius: "24px",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10)",
    justifyContent: "space-between",
  },
}));

const RowStyledSimilar = styled.div`
  width: 88%;
  margin: auto;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
`;

const WrapperProductCard = styled.div`
  width: 200px !important;
  padding-bottom: 1px;
  position: relative;
  margin: 1px 8px 42px 8px;
`;

const WrapperKeyWord = styled.div`
  width: 100%;
  margin-top: 40px;
  display: block;
`;

const Keyword = styled.p`
  font-size: 1rem;
  font-weight: 600;
  line-height: 24px;
  color: rgb(37, 37, 37);
  display: flex;
  -webkit-box-align: center;
  align-items: center;

  ::before {
    content: "";
    width: 4px;
    color: rgb(225, 59, 48);
    background: rgb(225, 59, 48);
    display: inline-block;
    height: 32px;
    margin-right: 15px;
    border-radius: 3px;
  }
`;

export const ButtonSlideImage = styled.button`
  width: 30px;
  height: 30px;
  background: #f3f1f2;
  border-radius: 16px;
  border: none;
  position: absolute;
  top: 50%;
  left: ${({ left }) => left && 0};
  right: ${({ right }) => right && 0};
  transform: translate(0, -50%);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
`;

const RequireFieldAlert = styled.div`
  color: ${Primary};
  font-size: ${font.size.md};
  line-height: 20px;
  font-weight: 400;
  max-width: 50%;

  span {
    font-size: ${font.size.md};
    line-height: 20px;
    font-weight: 500;
  }
`;

const PreviewDialog = ({ isOpen = false, onClose, onSubmit }) => {
  const {
    dataUpload,
    dataUploadChoice,
    dataSimilar,
    uploadErrors,
    choiceErrors,
    formatKeyToFieldName,
  } = UseUpload();

  const [requiredField, setRequiredField] = useState([]);
  const [similarList, setSimilarList] = useState({
    similars: [],
    similar_product_from_other_seller: [],
    similar_product_to_other_seller: [],
  });

  useEffect(() => {
    const similarSeller = dataSimilar?.similar_seller || [];
    const similarAdmin = dataSimilar?.similar_admin || [];
    const similarToOtherSeller =
      dataSimilar?.similar_product_to_other_seller || [];
    const similarFromOtherSeller =
      dataSimilar?.similar_product_from_other_seller || [];

    setSimilarList((prev) => ({
      ...prev,
      similars: [...similarSeller, ...similarAdmin],
      similar_product_to_other_seller: similarToOtherSeller,
      similar_product_from_other_seller: similarFromOtherSeller,
    }));
  }, [dataSimilar]);

  useEffect(() => {
    let errorProductList = Object.keys(uploadErrors)?.map((key) => {
      const keyParts = key.split(/[\\[\].]/g).filter((elm) => elm);
      const mainKey = keyParts[0];
      let errorField = formatKeyToFieldName?.find(
        (item) => item?.key === mainKey,
      );
      return `${errorField?.value}`;
    });

    // choiceErrors
    let choiceErrorKey = Object.keys(choiceErrors)?.map((choice) =>
      choice?.split(/[\\[\].]/g).filter((elm) => elm),
    );

    let errorChoiceList = choiceErrorKey?.map((path) => {
      // eslint-disable-next-line no-unused-vars
      let [key, objIndex, ...objKey] = path;

      let errorItem = objKey.pop(); // get key name from last elem
      let errorField = formatKeyToFieldName?.find(
        (item) => item?.key === errorItem,
      );

      return dataUploadChoice.length > 1
        ? `${errorField?.value} ตัวเลือกสินค้าที่ ${+objIndex + 1}`
        : `${errorField?.value}`;
    });

    setRequiredField([...errorProductList, ...errorChoiceList]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadErrors, choiceErrors]);

  const isSaveDraftValid = [
    "user_id",
    "brand",
    "item_name",
    "item_code",
    "category",
    "product_types",
  ].every((required) => !Object.keys(uploadErrors).includes(required));

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 1024,
            display: "flex",
            justifyContent: "space-between",
          },
        },
      }}
    >
      <div style={{ height: "90%", overflow: "scroll" }}>
        <DialogTitle sx={{ p: 3, textAlign: "center" }}>
          {`ตัวอย่างแสดงรายละเอียดสินค้าบนหน้าเว็บไซต์`}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              borderRadius: "50%",
              border: "1px solid var(--lightgrey-color)",
              position: "absolute",
              right: 16,
              top: 16,
              color: "var(--primary-color)",
              "&:hover": {
                backgroundColor: "var(--hover-color)",
                border: "1px solid white",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            p: 3,
            width: "100%",
            "::-webkit-scrollbar": {
              display: "none",
            },
            "& .MuiBox-root": {
              maxWidth: "530px",
              mx: "auto",
            },
          }}
        >
          <ProductDetail
            dataUpload={dataUpload}
            dataUploadChoice={dataUploadChoice}
          />

          {dataUpload.bundles?.length !== 0 && (
            <WrapperKeyWord>
              <Keyword>สินค้าที่ใช้คู่กัน</Keyword>
              <RowStyledSimilar>
                {dataUpload.bundles?.map((product, index) => (
                  <WrapperProductCard key={`similar-product-${index}`}>
                    <ProductCardElement
                      id={product?.bundle?._id}
                      unit={product?.unit_th}
                      size={`${product?.bundle?.size?.width}m. x ${product?.bundle?.size?.height}m. x ${product?.bundle?.size?.thickness}mm.`}
                      colorCode={product?.bundle?.color?._id}
                      // sellerLogo={product.similar.product.user.seller.profile_image}
                      // sellerName={product.similar.product.user.seller.company_name}
                      src={
                        !!product?.bundle?.group_image?.product_display_image &&
                        product?.bundle?.group_image?.product_display_image.replace(
                          ".com",
                          ".com/150x150",
                        )
                      }
                      itemcode={product?.bundle?.product?.item_code}
                      itemname={product?.bundle?.product?.item_name}
                      price={product?.bundle?.group_price}
                      productType={product?.bundle?.product?.product_types
                        .map((data) => data.type_th)
                        .join(",")}
                    />
                  </WrapperProductCard>
                ))}
              </RowStyledSimilar>
            </WrapperKeyWord>
          )}

          {similarList?.similars?.length !== 0 && (
            <WrapperKeyWord>
              <Keyword>สินค้าที่คล้ายกัน</Keyword>
              <RowStyledSimilar>
                {similarList?.similars?.map((product, index) => (
                  <WrapperProductCard key={`similar-product-${index}`}>
                    <ProductCardElement
                      id={product?.similar?._id}
                      size={`${product?.similar?.size?.width}m. x ${product?.similar?.size?.height}m. x ${product?.similar?.size?.thickness}mm.`}
                      colorCode={product?.similar?.color?._id}
                      sellerLogo={
                        product.similar.product.user.seller.profile_image
                      }
                      sellerName={
                        product.similar.product.user.seller.company_name
                      }
                      src={
                        !!product?.similar?.group_image
                          ?.product_display_image &&
                        product?.similar?.group_image?.product_display_image?.replace(
                          ".com",
                          ".com/150x150",
                        )
                      }
                      itemcode={product?.similar?.product?.item_code}
                      itemname={product?.similar?.product?.item_name}
                      price={product?.similar?.group_price}
                      productType={product?.similar?.product?.product_types
                        .map((data) => data.type_th)
                        .join(",")}
                    />
                  </WrapperProductCard>
                ))}
              </RowStyledSimilar>
            </WrapperKeyWord>
          )}
        </DialogContent>
      </div>

      <DialogActions sx={{ px: 5, py: 3 }}>
        {!!Object.keys(uploadErrors).length ||
        !!Object.keys(choiceErrors).length ? (
          <RequireFieldAlert>
            กรุณาใส่ข้อมูล {`${requiredField.slice(0, 2).join(", ")}`}{" "}
            {requiredField.slice(2).length > 0 ? (
              <Tooltip title={requiredField.slice(2).join(", ")}>
                <span style={{ cursor: "pointer", fontWeight: 600 }}>
                  และอื่น ๆ
                </span>
              </Tooltip>
            ) : null}{" "}
            ก่อนกดยืนยัน
          </RequireFieldAlert>
        ) : (
          <div></div>
        )}

        <Stack direction="row" alignItems="center" gap="12px">
          {dataUpload?._id === null || dataUpload?.status === "draft" ? (
            <Button
              variant="outlined"
              size="large"
              disabled={!isSaveDraftValid}
              onClick={() => onSubmit("draft")}
              sx={{ minWidth: 160, borderRadius: 4, py: 1.5 }}
            >
              {getLocale() === "th" ? "บันทึกร่าง" : "Save draft"}
            </Button>
          ) : null}

          <Button
            variant="contained"
            size="large"
            disabled={
              !!Object.keys(uploadErrors).length ||
              !!Object.keys(choiceErrors).length
            }
            onClick={() => onSubmit("save")}
            sx={{ minWidth: 160, borderRadius: 4, py: 1.5 }}
          >
            {dataUpload?._id && dataUpload?.status !== "draft"
              ? getLocale() === "th"
                ? "อัพเดท"
                : "Update"
              : getLocale() === "th"
                ? "ยืนยัน"
                : "Confirm"}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDialog;
